import { fetchJson } from "../utils/fetch";
import { API_URL } from "../config";
import { Admin } from "../model/Admin";

export const UserManagerApi = {
  unlock: async (id: string): Promise<Admin> => {
    const { data } = await fetchJson(`${API_URL}/users/unlock/${id}`, {
      method: "POST",
    });
    return data;
  },
  handDeduct: async (userId: string, amount: number): Promise<Admin> => {
    const { data } = await fetchJson(`${API_URL}/user/amount/handDeduct`, {
      method: "POST",
      body: new URLSearchParams({
        userId,
        amount: amount.toString(),
      }),
    });
    return data;
  },
  handPay: async (userId: string, amount: number): Promise<Admin> => {
    const { data } = await fetchJson(`${API_URL}/user/amount/handPay`, {
      method: "POST",
      body: new URLSearchParams({
        userId,
        amount: amount.toString(),
      }),
    });
    return data;
  },
};
